import { createContext, useContext, useMemo, useState, Dispatch, SetStateAction } from 'react';

export interface AppConfig {
  /**
   * App Bar Title.
   */
  appBarTitle?: React.ReactNode;
  /**
   * No Body padding
   */
  noPagePadding?: boolean;
}

interface AppConfigState {
  config: AppConfig;
  setConfig: Dispatch<SetStateAction<AppConfig>>;
}

const defaultConfig: AppConfigState = {
  config: {
    appBarTitle: '',
  },
  setConfig: () => void 0,
};

export const Context = createContext(defaultConfig);
export const useSetter = () => useContext(Context);

export const Provider = ({ children }) => {
  const [config, setConfig] = useState(defaultConfig.config);
  const configState: AppConfigState = useMemo(
    () => ({
      config,
      setConfig,
    }),
    [config, setConfig]
  );
  return <Context.Provider value={configState}>{children}</Context.Provider>;
};

export function use() {
  const { config } = useContext(Context);
  return config;
}
